var map = {
	"./2048.webp": 963,
	"./Bolts-and-Nuts.webp": 130,
	"./Bubble Blast.webp": 965,
	"./Car-Clash-2.webp": 821,
	"./Crazy-Drift.webp": 392,
	"./Crocword.webp": 330,
	"./Foono-Online-Multiplayer.webp": 277,
	"./Hextris.webp": 120,
	"./Nuts-Puzzle-Sort-By-Color.webp": 845,
	"./Racing-Limits.webp": 349,
	"./Super-Star-Car.webp": 848,
	"./Wood-Block-Journey.webp": 37,
	"./Xtreme-DRIFT-Racing.webp": 85,
	"./bg.jpg": 150,
	"./hyper-jump-3d.webp": 11,
	"./logo.png": 806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;